<template>
  <div class="form-group">
    <a class="pdf-link" target="_blank" :href="fileUrl">
      <img class="icon-pdf" alt="icon-pdf" v-if="iconSrc" :src="iconSrc"/>
      {{ text }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'FileLink',

  props: {
    fileUrl: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    iconSrc: {
      type: String,
      default: null
    }
  }
}
</script>
